<div class="doctor-container">
    <div class="doctor">
        @if (doctor.name !== 'labor') {
            <div class="name">
                <b [ngStyle]="{ 'font-size': '18px' }">{{ doctor.name }},&ensp;</b>
                @for (speciality of specialities; track speciality; let i = $index) {
                    <div>
                        <div [ngStyle]="{ display: 'flex' }">
                            <b [ngStyle]="{ 'font-size': '18px' }">{{ speciality.jobTitle }}&ensp;</b>
                        </div>
                    </div>
                }
            </div>
        }
        <div class="doctor-image-consulting-container">
            <div class="image-consulting-hour-container">
                <div class="image">
                    <img [src]="doctor.image" />
                </div>
                <div class="consulting-hour-container">
                    <h3>Rendelési idő:</h3>
                    <div class="consult">
                        @for (consultingHour of doctorConsultingHoursList; track consultingHour) {
                            <div class="consulting-hours">
                                <div class="consulting-hour">
                                    <div class="span-class">
                                        @if (consultingHour.startTime !== null && consultingHour.endTime !== null) {
                                            <span>
                                                {{ consultingHour.day }}: {{ consultingHour.startTime }} -
                                                {{ consultingHour.endTime }}</span
                                            >
                                        }
                                    </div>
                                    <div class="span-class">
                                        @if (consultingHour.startTime === null && consultingHour.endTime === null) {
                                            <span>{{ consultingHour.day }}: változó</span>
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div class="iframe-intr">
                @if (doctor.reservationLink) {
                    <div class="iframe">
                        <iframe
                            class="responsive-iframe"
                            title="Időpontfoglalás"
                            width="800"
                            height="500"
                            frameborder="0"
                            [src]="doctor.reservationLink! | iframeUrl"
                        ></iframe>
                    </div>
                }
                <div class="introduction">
                    <!-- <p>{{ doctor.introduction }}</p> -->
                    <div [innerHTML]="doctor.introduction"></div>
                </div>
            </div>
        </div>
    </div>
</div>
